export const editButtonStyles = {
  minWidth: 0,
};
